import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

function santa() {
  setTimeout(function () {
    let element: any = document.getElementsByClassName("page_number");

    // console.log(element)
    // let rand_val = Math.floor(Math.random() * (0 - 12) + 12);
    // console.log(rand_val)
    element[0].dispatchEvent(new Event("click", { bubbles: true }));
    run_bootstrap();
  }, 2000);
}

function run_bootstrap() {
  let myurl = "https://yuva-dev.mybharats.in";
  let abcurl = "";
  if (window.location.origin === "https://cv-beta.mybharats.in/") {
    myurl = "https://yuva-beta.mybharats.in";
  }
  if (window.location.origin === "https://cv.mybharat.gov.in") {
    myurl = "https://mybharat.gov.in";
    abcurl = "https://mybharat.gov.in";
  } else {
    abcurl = myurl;
  }

  // addded changes
  let yuva_profile = myurl + "/reports/yuva_profile";
  let public_profile = abcurl + "/youth-profile";
  if (myurl == "https://yuva-beta.mybharats.in") {
    public_profile = "https://yuva-beta.mybharats.in" + "/youth-profile";
  }
  let check_user_logout = abcurl + "/users/check_user_logout";
  let edityuvaprofile = myurl + "/users/edityuvaprofile";
  let dashboard_profile = myurl + "/yuth";

  let calendar = myurl + "tasks/event_calendar";
  let help_center = myurl + "/discussions/index";
  let discussion = myurl + "/discussions/discussion_forum";
  window.localStorage.setItem("http_host", myurl);

  // Check if the elements exist before accessing them

  // let elementsToSetHref = [{"id":"mybharaturlid","href":dashboard_profile}, {"id":"mybharaturlid_desk","href":abcurl}, {"id":"myaccount","href":edityuvaprofile}, {"id":"viewprofile","href":yuva_profile},{ "id":"publicprofile","href":public_profile},{"id":"logout","href":check_user_logout}, {"id":"back_button","href":public_profile},{ "id":"mobile_back_button","href":public_profile},{ "id":"beta_dash","href":dashboard_profile},{ "id":"url_discussion","href":discussion},{ "id":"url_helpcenter","href":help_center},{ "id":"url_calendar","href":calendar}];
  let elementsToSetHref = [
    { id: "mybharaturlid_desk", href: abcurl },
    { id: "myaccount", href: edityuvaprofile },
    { id: "viewprofile", href: yuva_profile },
    { id: "publicprofile", href: public_profile },
    { id: "logout", href: check_user_logout },
    { id: "back_button", href: public_profile },
    { id: "mobile_back_button", href: public_profile },
    { id: "beta_dash", href: dashboard_profile },
    { id: "url_discussion", href: discussion },
    { id: "url_helpcenter", href: help_center },
  ];

  elementsToSetHref.forEach((data) => {
    let element: any = document.getElementById(data.id);
    console.log(element, data);
    if (element) {
      if (element.href) {
        element.href = data.href;
      }
    }
  });
}

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

document.addEventListener("DOMContentLoaded", function () {
  const logoElement = document.getElementById("myBharatLogo") as HTMLImageElement;
  if (logoElement) {
    const logoURL = import.meta.env.VITE_LOGO_URL;
    if (logoURL) {
      logoElement.src = logoURL;
      console.log("Logo URL loaded from env:", logoURL);
    }
  }
  // Your custom JavaScript code here
  //   console.log('React scripts have loaded. Running additional JavaScript.');

  //   // Example: Change the background color after React scripts have loaded
  //   // santa();
  //   console.log(">>>>>>astera",document.getElementsByClassName("items-start"))
  //   if(document.getElementsByClassName("items-start")[0] && document.getElementsByClassName("items-start")[0]['clientHeight']){

  //   console.log(">>>>>>aster",document.getElementsByClassName("items-start")[0]['clientHeight'])
  // }
  // Add any other custom logic you need
});
